/* IMPORT ENTITIES AND RESOLVERS */
import { LabelingWorkflow } from './labeling-workflow'
import { WorkflowExecution } from './workflow-execution'
import { WorkflowExecutionStep } from './workflow-execution-step'
import { LabelingWorkflowService } from './labeling-workflow-service'

export const entities = [
  /* ENTITIES */
  LabelingWorkflow,
  WorkflowExecution,
  WorkflowExecutionStep
]

export const schema = {
  resolverClasses: [
    /* RESOLVER CLASSES */
    LabelingWorkflowService
  ]
}
